<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectLayout-1n" id="_idParaDest-1">
<div id="_idContainer002"><a id="_idTextAnchor000"></a>
<img alt="" class="_idGenObjectAttribute-1" src="image/title.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer003">
<img alt="" class="_idGenObjectAttribute-1" src="image/telephone_isolated.png" style="width: 30%;"/>
</div>
</div>
<div class="_idGenObjectStyleOverride-1 pb" id="_idContainer004">
<p class="ebook-toc" id="_idParaDest-2"><a id="_idTextAnchor001"></a>Author’s Note</p>
<p class="Stories-body-text">These stories are the product of a fascination with microfiction, a love of eccentric tales, and a New Year’s resolution to write one 55-word story a day (which lasted till May 5; I have a thing for tidy endings).</p>
<p class="Stories-body-text">I suggest two or three stories as part of your recommended daily literary intake.</p>
<p class="Stories-body-text">Happy reading!</p>
</div>
<div class="_idGenObjectLayout-1n t2">
<div id="_idContainer005">
<img alt="" class="_idGenObjectAttribute-1" src="image/stool-isolated.png" style="width: 40%;"/>
</div>
</div>
<div class="_idGenObjectStyleOverride-1 pb" id="_idContainer006">
<p class="ebook-toc" id="_idParaDest-3"><a id="_idTextAnchor002"></a>Contents</p>
</div>
<div class="_idGenObjectStyleOverride-1" epub:type="toc" id="_idContainer007">
<p class="TOC t"><a href="#/55SSS_epub#_idTextAnchor004">The Best-Laid Plans</a></p>
<p class="TOC"><a href="#/55SSS_epub#_idTextAnchor005">He Loves Me, He Loves Me Not (Part I)</a></p>
<p class="TOC"><a href="#/55SSS_epub#_idTextAnchor006">Growing Pains</a></p>
<p class="TOC"><a href="#/55SSS_epub#_idTextAnchor007">Lucky Duck</a></p>
<p class="TOC"><a href="#/55SSS_epub#_idTextAnchor008">Artistic Appreciation</a></p>
<p class="TOC"><a href="#/55SSS_epub1#_idTextAnchor009">Backseat Driver</a></p>
<p class="TOC"><a href="#/55SSS_epub1#_idTextAnchor010">Complementary</a></p>
<p class="TOC"><a href="#/55SSS_epub1#_idTextAnchor011">Frankenstein Revisited</a></p>
<p class="TOC"><a href="#/55SSS_epub1#_idTextAnchor012">Art Attack</a></p>
<p class="TOC"><a href="#/55SSS_epub1#_idTextAnchor013">Lip Service</a></p>
<p class="TOC"><a href="#/55SSS_epub1#_idTextAnchor014">A Literary Death</a></p>
<p class="TOC"><a href="#/55SSS_epub1#_idTextAnchor015">Fashion Victim</a></p>
<p class="TOC"><a href="#/55SSS_epub1#_idTextAnchor016">Have Your Cake and Eat It Too </a></p>
<p class="TOC"><a href="#/55SSS_epub1#_idTextAnchor017">Some People Eat to Live . . .</a></p>
<p class="TOC"><a href="#/55SSS_epub1#_idTextAnchor018">At Sea</a></p>
<p class="TOC"><a href="#/55SSS_epub2#_idTextAnchor019">Blurring the Lines</a></p>
<p class="TOC"><a href="#/55SSS_epub2#_idTextAnchor020">Fatal Beauty</a></p>
<p class="TOC"><a href="#/55SSS_epub2#_idTextAnchor021">Deadly Detox</a></p>
<p class="TOC"><a href="#/55SSS_epub2#_idTextAnchor022">20/20ish</a></p>
<p class="TOC"><a href="#/55SSS_epub2#_idTextAnchor023">Seafarer</a></p>
<p class="TOC"><a href="#/55SSS_epub2#_idTextAnchor024">Ajar</a></p>
<p class="TOC"><a href="#/55SSS_epub2#_idTextAnchor025">Bun in the Oven</a></p>
<p class="TOC"><a href="#/55SSS_epub2#_idTextAnchor026">A Part of This Place</a></p>
<p class="TOC"><a href="#/55SSS_epub2#_idTextAnchor027">Enemy Territory</a></p>
<p class="TOC"><a href="#/55SSS_epub2#_idTextAnchor028">Food for Thought</a></p>
<p class="TOC"><a href="#/55SSS_epub3#_idTextAnchor029">He Loves Me, He Loves Me Not (Part II)</a></p>
<p class="TOC"><a href="#/55SSS_epub3#_idTextAnchor030">Dinner Forks</a></p>
<p class="TOC"><a href="#/55SSS_epub3#_idTextAnchor031">Lovesick</a></p>
<p class="TOC"><a href="#/55SSS_epub3#_idTextAnchor032">Last Request</a></p>
<p class="TOC"><a href="#/55SSS_epub3#_idTextAnchor033">Sink or Swim</a></p>
<p class="TOC"><a href="#/55SSS_epub3#_idTextAnchor034">Hansel and Gretel 2019</a></p>
<p class="TOC"><a href="#/55SSS_epub3#_idTextAnchor035">Mis-conception</a></p>
<p class="TOC"><a href="#/55SSS_epub3#_idTextAnchor036">Farmers<span>’</span> Market</a></p>
<p class="TOC"><a href="#/55SSS_epub3#_idTextAnchor037">Miscalculation</a></p>
<p class="TOC"><a href="#/55SSS_epub3#_idTextAnchor038">Testing the Waters</a></p>
<p class="TOC"><a href="#/55SSS_epub4#_idTextAnchor039">Pet Cemetery</a></p>
<p class="TOC"><a href="#/55SSS_epub4#_idTextAnchor040">The End (Part I)</a></p>
<p class="TOC"><a href="#/55SSS_epub4#_idTextAnchor041">It Only Takes a Minute</a></p>
<p class="TOC"><a href="#/55SSS_epub4#_idTextAnchor042">The Nose Knows</a></p>
<p class="TOC"><a href="#/55SSS_epub4#_idTextAnchor043">Symbiosis</a></p>
<p class="TOC"><a href="#/55SSS_epub4#_idTextAnchor044">You Are Always on My Mind</a></p>
<p class="TOC"><a href="#/55SSS_epub4#_idTextAnchor045">Weighed Down</a></p>
<p class="TOC"><a href="#/55SSS_epub4#_idTextAnchor046">Shell-shocked</a></p>
<p class="TOC"><a href="#/55SSS_epub4#_idTextAnchor047">Sibling Rivalry</a></p>
<p class="TOC"><a href="#/55SSS_epub4#_idTextAnchor048">Sound of Silence</a></p>
<p class="TOC"><a href="#/55SSS_epub5#_idTextAnchor049">Till Death</a></p>
<p class="TOC"><a href="#/55SSS_epub5#_idTextAnchor050">X Marks the Spot</a></p>
<p class="TOC"><a href="#/55SSS_epub5#_idTextAnchor051">Glass Half-Empty</a></p>
<p class="TOC"><a href="#/55SSS_epub5#_idTextAnchor052">Unrequited</a></p>
<p class="TOC"><a href="#/55SSS_epub5#_idTextAnchor053">Osmosis</a></p>
<p class="TOC"><a href="#/55SSS_epub5#_idTextAnchor054">Chart-Toppers</a></p>
<p class="TOC"><a href="#/55SSS_epub5#_idTextAnchor055">Destined to Be Apart</a></p>
<p class="TOC"><a href="#/55SSS_epub5#_idTextAnchor056">Bite Me </a></p>
<p class="TOC"><a href="#/55SSS_epub5#_idTextAnchor057">Domestic Bliss</a></p>
<p class="TOC"><a href="#/55SSS_epub5#_idTextAnchor058">The End (Part II)</a></p>
</div>
<div class="_idGenObjectLayout-1n">
<div id="_idContainer008">
<img alt="" class="_idGenObjectAttribute-1" src="image/Blurring_the_Lines_-_modified_2.png" style="width: 50%;"/>
</div>
</div>
<div class="_idGenObjectStyleOverride-1 pb" id="_idContainer010">
<p class="ebook-toc" id="_idParaDest-4"><a id="_idTextAnchor003"></a>The Stories</p>
</div>
<div class="_idGenObjectLayout-1n">
<div id="_idContainer009">
<img alt="" class="_idGenObjectAttribute-1" src="image/p8.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer011">
<img alt="" class="_idGenObjectAttribute-1" src="image/Best_Laid_Plans.png"/>
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer012">
<p class="Stories-titles"><a id="_idTextAnchor004"></a>The Best-Laid Plans</p>
<p class="Stories-body-text">He was sweet, quirky, and smitten. She could tell him anything. They laughed at the same idiotic things and planned wildly unfeasible trips. </p>
<p class="Stories-body-text">He was like family, that’s all. He was her backup, her Plan B.</p>
<p class="Stories-body-text">She eyed the wedding invite warily. It hadn’t occurred to her that he might be someone else’s Plan A.</p>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer013">
<img alt="" class="_idGenObjectAttribute-1" src="image/He_Loves_Me-He_Lovs_Me_Not__1_.png"/>
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer014">
<p class="Stories-titles"><a id="_idTextAnchor005"></a>He Loves Me, He Loves Me Not (Part I)</p>
<p class="Stories-body-text">He remembers her when it snows. That’s how they met forty years ago, two clueless souls searching for a donut fix in a blizzard. </p>
<p class="Stories-body-text">They live in California now, and he keeps looking at her with vacant eyes. </p>
<p class="Stories-body-text">She thumbs through the Alaska brochures, contemplating a future where he smiles when  she enters a room. </p>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer015">
<img alt="" class="_idGenObjectAttribute-1" src="image/Growing_Pains.png"/>
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer016">
<p class="Stories-titles"><a id="_idTextAnchor006"></a>Growing Pains</p>
<p class="Stories-body-text">The spring before turning thirteen, they discovered a hole in the wall between their two schools, big enough for a petite preteen or her gangly crush to squeeze through.  </p>
<p class="Stories-body-text">Puberty had other plans, though. Over the summer, her chest filled out and his shoulders broadened, making the scramble through impossible.  </p>
<p class="Stories-body-text">They simply outgrew each other.</p>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer017">
<img alt="" class="_idGenObjectAttribute-1" src="image/Lucky_Duck.png"/>
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer018">
<p class="Stories-titles"><a id="_idTextAnchor007"></a>Lucky Duck</p>
<p class="Stories-body-text">The day their love died, so did an unsuspecting duck. </p>
<p class="Stories-body-text">Done with weeping on a park bench, she flung her engagement ring into the lake. It had been handed down through generations, only to get lodged in the greedy bird’s gullet. </p>
<p class="Stories-body-text">He would want the ring back. She hoped he wouldn’t mind the unconventional wrapping.</p>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer019">
<img alt="" class="_idGenObjectAttribute-1" src="image/Artistic_Appreciation.png"/>
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer020">
<p class="Stories-titles"><a id="_idTextAnchor008"></a>Artistic Appreciation</p>
<p class="Stories-body-text">He was painfully beautiful up close. She wanted to drink in his lines as though he were one of her favorite roped-off paintings. </p>
<p class="Stories-body-text">There was a bare wall in her new apartment that needed adornment. </p>
<p class="Stories-body-text">She invited him for drinks, admiring the way the rust-colored paint brought out the flecks of gold in his eyes.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 55SSS_epub.vue?48731a50